import { render, staticRenderFns } from "./IconTickLinear.vue?vue&type=template&id=54b2a4fe&scoped=true"
import script from "./IconTickLinear.vue?vue&type=script&lang=js"
export * from "./IconTickLinear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b2a4fe",
  null
  
)

export default component.exports